// Onboarding-related constants

export const HOW_IT_WORKS_STEPS = [
  {
    title: 'Pick a Porvenix Market',
    description:
      "Buy 'Yes' or 'No' shares depending on your prediction. Buying shares is like betting on the outcome. Odds shift in real time as other traders bet.",
  },
  {
    title: 'Place a Bet',
    description:
      "Fund your account with crypto, credit/debit card, or bank transfer—then you're ready to bet. No bet limits and no fees.",
  },
  {
    title: 'Profit',
    description:
      "Sell your 'Yes' or 'No' shares at any time, or wait until the market ends to redeem winning shares for $1 each. Create an account and place your first trade in minutes.",
  },
] as const;
